<template>
  <f7-page id="reg-mobile-no" name="reg-mobile-no" @page:afterin="afterin">
      <f7-navbar class="view-mobile no-border">
          <f7-nav-left class="back-button">
              <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
          </f7-nav-left>
          <f7-nav-right></f7-nav-right>
      </f7-navbar>
      <f7-block>
        <div class="row mb-20 pb-md">
          <div class="fs-24 b mb-md">{{$t('regis-enter-mobile-no')}}</div>
          <div class="fs-14 fw-medium text-color-gray">
            {{$t('regis-enter-mobile-no-text')}}
          </div>
        </div>

        <div>
          <transition name="fade">
            <f7-card
                class   ="alert alert-danger mb-md"
                v-show  ="alertCard.show"
            >
                <div v-html="alertCard.title" slot="header"></div>
                <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
            </f7-card>
          </transition>
          
          <!-- <MyInfoRegisterMobileNo
            :key = "componentKey"
            @onSearch="onSearch"
            @changeMobilePhoneCode="changeMobilePhoneCode"
            @validateInput="validateInput"
            @setMobileNoState="setMobileNoState"
            :countryCodeList="countryCodeList"
          /> -->

          <f7-list class="form-group no-margin">
            <f7-list-input
              id            ="mobileNoListId"
              input-id      ="mobileNo"
              name          ="mobileNo"
              type          ="tel"
              class         ="mobile-input"
              :label        ="$t('regis-mob-num')"
              :value        ="mobileNum"
              placeholder   =""
              @input        = "setInputValue($event.target)"
              maxlength     ="15"
              autocomplete  ="off"
              outline
              floating-label
              clear-button
            >
              <f7-link id="regCountryCode" popover-open=".popover-mobile-no" slot="content-start" class="flag-with-chevron">
                <img :src="getFlagImg(mobileCountryId)" class="" />
                <span class="">{{ mobileCountryIdd }}</span>
              </f7-link>
            </f7-list-input>

            <f7-popover id="regMobileNoDropdown" class="popover-mobile-no mobile-country-code register" :backdrop="true">
              <f7-searchbar id="regMobileCountryCodeSearch" search-container=".country-code-list" search-in=".country-name" @searchbar:search="onSearch"></f7-searchbar>
              <f7-list class="searchbar-not-found">
                <f7-list-item :title="$t('beneficiary-no-found')"></f7-list-item>
              </f7-list>
              <f7-list class="country-code-list">
                  <f7-list-item popover-close class="text-align-left" link="#"
                  v-for="mIDD in countryCodeList"
                  :key="mIDD.id"
                  @click="changeMobilePhoneCode(mIDD.countryId)">
                    <img :src="getFlagImg(mIDD.countryId)" class="mr-sm"/>
                    <span class="country-name">{{mIDD.countryName+" "+mIDD.countryIDD}}</span>
                  </f7-list-item>
              </f7-list>
            </f7-popover>

          </f7-list>
        </div>
        <f7-button round large fill @click="goToNextPage" class="mt-5 view-desktop" :disabled="!isNextButtonValid">{{$t('label-common-next')}}</f7-button>
      </f7-block>

      <f7-toolbar position="bottom" no-hairline class="toolbar-with-button view-mobile">
        <f7-button large fill @click="goToNextPage" :disabled="!isNextButtonValid">
            {{$t('label-common-next')}}
        </f7-button>
      </f7-toolbar>
  </f7-page>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import store from '../../store'
  import { check } from '@/plugins/helper';
  import { debounce } from 'lodash'; 

  //import MyInfoRegisterMobileNo from '../../components/myinfo-register-mobile-phone.vue';

  export default {
    mounted (){
      this.loadCountry();
      if(this.mobileCountryId == 0 && this.mobileCountryIdd == ""){
        this.setMobileCountryId({
          id: 189,
          idd: "+65"
        })
      }
      
      /*
      const popover = ".register.popover-mobile-no";
      const popoverInner = ".register.popover-mobile-no .popover-inner";
      const popoverId = "regMobileNoDropdown";
      const inputId = "mobileNoListId";
      const searchbarId = "reg-country-code-search-bar";
      this.setDropdownCountryCode(popover, popoverInner, popoverId, inputId, searchbarId)
      */

      this.init()
      this.validateInput({name: "mobileNo", value: this.mobileNum})
    },
    data() {
      return {
        mobileNo              : "",
        mobileIDD             : 189,
        mobileIDDCode         : "+65",
        isNextButtonValid     : false,
        currentHomeId         : 189,
        countryCodeList       : [],
        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },
        componentKey          : 0
      };
    },
    methods: {
      ...mapActions('registration', [
            'registerNew2',
            'setMobileNum',
            'setMobileCountryId'
        ]),
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },

      init() {
        const self    = this;
        const popover = ".register.popover-mobile-no";
        const popoverInner = ".register.popover-mobile-no .popover-inner";
        const popoverId = "regMobileNoDropdown";
        const inputId = "mobileNo";
        const inputListId = "#mobileNoListId";

        //self.Dom7(popover).on('popover:open', function () {
            self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId, "mobile-input", "regCountryCode", "regMobileCountryCodeSearch")
        //});
      },

      setMobileNoState(val){
        this.mobileNo = val
      },

      async loadCountry(){
        const countryPromise = await this.$api.registration.getCountryList();

        const filteredCountryPromise = countryPromise.filter((result) => {
          return result.isHidden == 0
        });

        filteredCountryPromise.forEach(function(item,i){
            if(item.countryId === 189){
              filteredCountryPromise.splice(i, 1);
              filteredCountryPromise.unshift(item);
            }
          });

        this.countryCodeList = filteredCountryPromise;
      },
      validateInput(e) {
        var regex = /^[0-9]{6,15}$/;
        var validate;
        if(regex != ""){
          //console.log("LENGTH : "+e.value.length)

          if(isNaN(e.value)){
            this.setInputState(e.name, this.$t('regis-mobileNum-rule'));
            this.isNextButtonValid = false;
            return false;
          }else{
            if(e.value.length >= 6){
              if(this.mobileCountryId == "189"){ // SG
                validate = check.validPattern("mobilephone189", e.value);
              }else{
                validate = regex.test(e.value);
              }

              if(!validate){
                if(this.mobileCountryId == "189"){ // SG
                  this.setInputState(e.name, this.$t('regis-mobileNum-rule-189'));
                }else{
                  this.setInputState(e.name, this.$t('regis-mobileNum-rule'));
                }
                this.isNextButtonValid = false;
                return false;
              }
            }else{
              this.isNextButtonValid = false;
              return false;
            }
          }
        }

        this.isNextButtonValid = true;
        this.setInputState(e.name, true);
        return true;
      },
      async goToNextPage(){
        this.showPreloader();

        var registrationData = store.state.registration;
        registrationData.mobileNum = this.mobileNum;
        registrationData.customerAlias = this.isSkipAlias === true ? "" : this.customerAlias;

        var regOTP = store.state.misc;

        const requestOtp = await this.$api.registration.registerNew2(registrationData);

        if(requestOtp.status == "4000"){
          regOTP.otp.routerTo = 'registerTnc';
          this.$f7router.navigate("/otp");
          this.hidePreloader();
        }else if(requestOtp.status == "WN00105" || requestOtp.status == "WN00106" || requestOtp.status == "WN00107"){
          let sgTime = new Date().toLocaleString("en-US", {timeZone: 'Asia/Singapore'});
          const now = new Date(sgTime).getHours();

          if (now >= 9 && now <= 18) {
            this.showAlert(true, this.$t('regis-mobileNum-exist', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
          } else {
            this.showAlert(true, this.$t('regis-mobileNum-exist-after-business-hours', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
          }

          this.hidePreloader();
        }else{
          console.log("REQUEST REGISTER OTP ERROR! Status : "+requestOtp.status);
          this.hidePreloader();
        }
      },
      changeMobilePhoneCode(mobileId) {
          for(let i=0; i < this.countryCodeList.length; i++) {
              let thisMobileCC = this.countryCodeList[i]
              if(thisMobileCC.countryId == mobileId) {
                  this.mobileIDDCode = thisMobileCC.countryIDD;
                  this.mobileIDD     = thisMobileCC.countryId;
                  this.setMobileCountryId({
                    id: thisMobileCC.countryId,
                    idd: thisMobileCC.countryIDD
                  })

                  // VALIDATE MOBILE NO. VALUE
                  if(isNaN(this.mobileNum)){
                    this.setInputState("mobileNo", this.$t('regis-mobileNum-rule'));
                    this.isNextButtonValid = false;
                    return false;
                  }else{
                    var regex = /^[0-9]{8,15}$/;
                    if(this.mobileNum.length > 7){
                      var validate;
                      if(thisMobileCC.countryId == "189"){ // SG
                        validate = check.validPattern("mobilephone189", this.mobileNum);
                      }else{
                        validate = regex.test(this.mobileNum);
                      }

                      if(!validate){
                        if(thisMobileCC.countryId == "189"){ // SG
                          this.setInputState("mobileNo", this.$t('regis-mobileNum-rule-189'));
                        }else{
                          this.setInputState("mobileNo", this.$t('regis-mobileNum-rule'));
                        }
                        this.isNextButtonValid = false;
                      }else{
                        this.isNextButtonValid = true;
                        this.setInputState("mobileNo", true);
                      }
                    }else{
                      let validateInput = false;
                      if(thisMobileCC.countryId == "189"){ // SG
                        validateInput = check.validPattern("mobilephone189", this.mobileNum);
                      }else{
                        validateInput = regex.test(this.mobileNum);
                      }

                      if(validateInput){
                        this.setInputState("mobileNo", true);
                        this.isNextButtonValid = true;
                      }else{
                        if(thisMobileCC.countryId == "189"){ // SG
                          this.setInputState("mobileNo", this.$t('regis-mobileNum-rule-189'));
                          this.isNextButtonValid = false;
                        }else{
                          if(this.mobileNum.length >= 6){
                            this.setInputState("mobileNo", true);
                            this.isNextButtonValid = true;
                          }else{
                            this.setInputState("mobileNo", false);
                            this.isNextButtonValid = false;
                          }
                        }
                      }
                    }
                  }

                  break;
              }
          }
      },
      backButton() {
        if(this.isAxsr){
          this.$f7router.navigate("/register-personalise-account");
        }else{
          if(this.singpassUrl != ""){
            this.$f7router.navigate("/register-email-password");
          }else{
            this.$f7router.navigate("/register-personalise-account");
          }
        }
      },
      showAlert(status, title, content){
        this.alertCard.show = status;
        if (title == undefined){
          title = "";
        }
        if (content == undefined){
          content = "";
        }
        this.alertCard.title= title;
        this.alertCard.content = content;

      },
      onSearch(){
        const self    = this;
        if(self.latestCountryCodePopoverDirection == "above"){
          const popover = ".register.popover-mobile-no";
          const popoverInner = ".register.popover-mobile-no .popover-inner";
          const popoverId = "regMobileNoDropdown";
          const inputId = "mobileNo";
          const inputListId = "#mobileNoListId";

          self.setPopoverPosition(popover, popoverInner, popoverId, inputId, inputListId, "mobile-input", "regCountryCode", "regMobileCountryCodeSearch", true)
        }
      },

      setInputValue(el){
        const self         = this;
        const debouncedValue = debounce(function () {
            //console.log("element : ", el);
            self.mobileNo = el.value;
            self.setMobileNum(el.value);
            self.validateInput(el);
        }, 1000);

        debouncedValue();
      }
    },
    components: {
      //MyInfoRegisterMobileNo
    },
    computed: {
      ...mapGetters('registration', [
          'mobileCountryId',
          'mobileCountryIdd',
          'mobileNum',
          'isSkipAlias',
          'singpassUrl',
          'isAxsr'
        ]),
      ...mapGetters('customer', [
          'customerAlias',
        ]),
      ...mapGetters('misc', [
          'latestCountryCodePopoverDirection',
        ])
    },
  }
</script>